import type { TaskId } from "./db/schema";
import { buildTenantPath } from "./tenant";

export namespace RoutePattern {
	export const root = "/" as const;
	export const login = "/login" as const;
	export const error = "/error" as const;
	export const admin = "/admin" as const;
	export const uikit = "/uikit" as const;
	export const taskList = "/task" as const;
	export const taskDetail = "/task/:taskId" as const;
	export const trainingGuide = "/training-guide" as const;
}

export namespace Routes {
	export const root = "/";
	export const login = "/login";
	export const error = "/error";
	export const admin = "/admin";
	export const uikit = "/uikit";
	export const taskList = "/task";
	export const taskDetail = (taskId: TaskId) => `/task/${taskId}` as const;
	export const trainingGuide = "/training-guide";
}

export type StaticRoute =
	| typeof Routes.root
	| typeof Routes.login
	| typeof Routes.error
	| typeof Routes.admin
	| typeof Routes.uikit
	| typeof Routes.taskList
	| typeof Routes.trainingGuide;

export function absoluteRoute(path: StaticRoute): string {
	return `${window.location.origin}${buildTenantPath(path)}`;
}
